import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import Header from './Header';
import Layout from './Layout';


const Terms = () => {
  const [headingStyle, setHeadingStyle] = useState({ fontSize: '32px' });

  useEffect(() => {
    const updateHeadingSize = () => {
      const width = window.innerWidth;
      let fontSize = '32px';
      if (width < 480) fontSize = '20px';
      else if (width < 768) fontSize = '24px';
      else if (width < 1024) fontSize = '28px';
      
      setHeadingStyle({ fontSize });
    };

    updateHeadingSize();
    window.addEventListener('resize', updateHeadingSize);
    
    window.scrollTo(0, 0);
    return () => window.removeEventListener('resize', updateHeadingSize);
  }, []);

  return (
    <>
        {/* <Header /> */}
                    <Layout>
      <div style={styles.container}>
        <h1 style={headingStyle}>Cookie Policy</h1>

        <p>This Cookie Policy explains how <strong>RZTO Token</strong> ("we," "us," or "our") uses cookies and similar
            technologies to recognize you when you visit our website https://rzto.io ("Website"). It explains what
            these technologies are and why we use them, as well as your rights to control our use of them.</p>

        <h2>1. What Are Cookies?</h2>

        <p>Cookies are small data files that are placed on your device when you visit a website. Cookies are widely used by
            website owners to make their websites work, improve functionality, and provide reporting information.</p>

        <p>Cookies set by the website owner (in this case, RZTO Token) are called "first-party cookies." Cookies set by
            parties other than the website owner are called "third-party cookies." Third-party cookies enable third-party
            features or functionality to be provided on or through the website (e.g., advertising, interactive content, and
            analytics).</p>

        <h2>2. Why We Use Cookies</h2>

        <p>We use cookies for several reasons:</p>
        <ul style={styles.list}>
            <li><strong>Essential Cookies</strong>: To enable basic functions like page navigation and secure areas of the
                Website. The Website cannot function properly without these cookies.</li>
            <li><strong>Performance and Analytics Cookies</strong>: To understand how visitors interact with our Website by
                collecting and reporting information anonymously.</li>
            <li><strong>Functionality Cookies</strong>: To remember choices you make (such as your username, language, or
                region) and provide enhanced, more personalized features.</li>
            <li><strong>Advertising Cookies</strong>: To deliver advertisements that are relevant to you and your interests.
            </li>
        </ul>

        <h2>3. Types of Cookies We Use</h2>

        <p>We use the following types of cookies:</p>
        <ul style={styles.list}>
            <li><strong>Session Cookies</strong>: Temporary cookies that remain on your device until you leave our Website.
            </li>
            <li><strong>Persistent Cookies</strong>: Cookies that remain on your device for a longer period or until you
                manually delete them.</li>
        </ul>

        <p>Examples of cookies we may use include:</p>
        <ul style={styles.list}>
            <li>Google Analytics</li>
            <li>Meta Pixel</li>
            <li>Custom RZTO tracking for promotions and rewards</li>
            <li>AI interaction tracking for improving user experiences</li>
        </ul>

        <h2>4. How You Can Control Cookies</h2>

        <p>You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls
            to accept or refuse cookies. If you choose to reject cookies, you may still use our Website, though your access
            to some functionality and areas may be restricted.</p>

        <p>You can manage your cookie preferences through:</p>
        <ul style={styles.list}>
            <li>Your browser settings (e.g., Chrome, Firefox, Safari)</li>
            <li>A cookie consent banner provided when you first visit our Website</li>
        </ul>

        <p>For more information on how to manage cookies, visit <a href="https://www.allaboutcookies.org/"
                target="_blank">www.allaboutcookies.org</a>.</p>

        <h2>5. Third-Party Cookies</h2>

        <p>In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the
            Website, deliver advertisements on and through the Website, and so on. These third parties include but are not
            limited to:</p>
        <ul style={styles.list}>
            <li>Google</li>
            <li>Facebook</li>
            <li>Twitter</li>
            <li>LinkedIn</li>
            <li>Other advertising networks and analytics providers</li>
        </ul>

        <h2>6. Updates to This Cookie Policy</h2>

        <p>We may update this Cookie Policy from time to time in order to reflect changes to the cookies we use or for other
            operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed about
            our use of cookies and related technologies.</p>

        <p>The date at the top of this Cookie Policy indicates when it was last updated.</p>

            </div>
      </Layout>
            
            </>
        );
        };

       const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    padding: '20px',
    color: '#333',
    margin: '30px auto',
    maxWidth: '70%',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'justify', // justifies paragraph text
  },
  effectiveDate: {
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center', // center the effective date text
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    margin: '10px 0',
    color: '#000',
    fontSize: '14px',
  },
  orderedList: {
    margin: '10px 0',
    paddingLeft: '20px',
    listStyleType: 'decimal',
  }
};

export default Terms;
